module.exports = __webpack_public_path__ + "static/media/twitter.7a5814f6.svg";